/** Mirrored memory frame state: globe, focus and trail, pocket, and review walk. */
import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";
import {
  createMemoryFrameSlice,
  initialFrameState,
  type MemoryFrameSlice,
} from "@/stores/memory-frame-slice";

export type MemoryState = MemoryFrameSlice & { clear: () => void };

export const useMemoryStore = create<MemoryState>()(
  mirroredStore("memory", (set, get, api) => ({
    ...createMemoryFrameSlice(set, get, api),
    clear: () => set(initialFrameState()),
  })),
);
